import { render, staticRenderFns } from "./TalkToMeJr.vue?vue&type=template&id=5429b461&"
import script from "./TalkToMeJr.vue?vue&type=script&lang=ts&"
export * from "./TalkToMeJr.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports